import React from "react";
import PrequalForm from "@/components/PrequalForm";

const Precalificacion = () => {
  return (
    <main className="bg-white pt-28 lg:pt-32 pb-24">
      <section className="bg-razmek-alt py-16 lg:py-20">
        <div className="max-w-[1000px] mx-auto px-6 lg:px-10">
          <div className="eyebrow">Precalificación</div>
          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 leading-[1.05] text-razmek-dark">
            Diagnóstico patrimonial
            <br />
            <span className="italic text-razmek-blue">en 7 pasos</span>.
          </h1>
          <p className="mt-6 max-w-xl font-sans text-base lg:text-lg leading-relaxed text-razmek-dark/70">
            Información sin costo. Sin compromiso. Sin presión comercial. Un
            asesor revisará tu caso y te contactará en menos de 24 horas.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-20">
        <div className="max-w-[900px] mx-auto px-6 lg:px-10">
          <PrequalForm />
        </div>
      </section>
    </main>
  );
};

export default Precalificacion;
